export const data = {
  transactionsTabs: (interaction: string) => ({
    category: 'PainelHub:finance',
    action: 'click',
    label: `${interaction}`,
  }),
  print: (interaction: string) => ({
    category: 'PainelHub:finance',
    action: 'click',
    label: `${interaction}`,
  }),
}
